// Defining the area libary or timeline
import articleHtml from "src/components/article/article";
import postRenderArticle from "src/components/article/article_postrender";

import { articlesExtend, getDynamicContent, findsite } from "src/scripts/mixin";

export default () => {
    
    const contentcontainer = document.getElementById("site_content");

    
    // console.log(site, page);
    document.getElementById("site_content").classList.remove("container");
    
    
    let service = "findbynameinurl";
    
    if(window.page.match(/^([0-9a-fA-F]{8})-(([0-9a-fA-F]{4}\-){3})([0-9a-fA-F]{12})$/i)){
        service = "find";
    }
    const siteinfo = findsite();

    fetch(`${window.apiUrl}/api/PublicContentApi/${service}/${window.page}/${window.config.clientId}`).then(result => result.json()).then(item => {
        
        document.getElementById("articlehtml").innerHTML = articleHtml(item);
    
        document.title = item.title + " - " + siteinfo.previewItem + " - Kongsberg historiefortelling";
        // console.log("writing")
        postRenderArticle();
        
    })
    
    
    const r = `
        
        <div class="article" id="articlehtml"></div>
        
    `


    contentcontainer.innerHTML = r;
    
    // console.log("done");
    
    
}